import React, { Component } from "react";
import { Icon } from "antd";
import styled from "styled-components";
import PropTypes from "prop-types";
import typo from "../../../../constants/dictionaries"
import Button from "../../../../components/Buttons";
import Constant from "../../../../constants/constant";
import Api_quantrac from "../../../../api/api.quantrac"
import InfoTramQT from "../../../../components/License/BieuDo/mauQTModalMT"
import InfoTramQT_HTMT from "../../../../components/License/BieuDo/MauQTTram"
import InfoTramQT_TNNModal from "./mauQTModal"
const ControllerButton = styled.div`
  align-items: flex-end;
  padding-top: 10px;
  text-align: right;
`;
class RouterTramInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data_modal_mau: {}
        }
    }

    componentDidMount() {
        this.setState({ data_modal_mau: this.props.data_modal_mau })
    }
    componentDidUpdate(prevProps) {
        if (this.props.data_modal_mau != prevProps.data_modal_mau) {
            this.setState({ data_modal_mau: this.props.data_modal_mau })
        }
    }

    render() {
        const { user, handleCloseModal } = this.props
        const { data_modal_mau } = this.state
        return (
            <div>
                {data_modal_mau.loai === Constant.DIEM_QT_BANDO.DTM &&
                    <InfoTramQT
                        user={user}
                        phanloai="DTM"
                        data_modal_mau={data_modal_mau}
                        editable={true}
                        apiGetTPMT_Exist={new Api_quantrac().GetTPMT_Exist_DTM}
                        apiGetMauQT_by_Tram={new Api_quantrac().GetMauQTs_By_TramQT_DTM}
                        apiSoLan_VuotNguong={new Api_quantrac().GetBieuDo_SoLanVuotNguong_DTM}
                        apiThongSo_Exist={new Api_quantrac().GetThongSos_Exist_DTM}
                        apiGiaTriTimeLine={new Api_quantrac().GetBieuDo_ThongSos_GiaTris_Timeline_DTM}
                    />
                }

                {data_modal_mau.loai === Constant.DIEM_QT_BANDO.BVMT &&
                    <InfoTramQT
                        user={user}
                        phanloai="BVMT"
                        data_modal_mau={data_modal_mau}
                        editable={true}
                        apiGetTPMT_Exist={new Api_quantrac().GetTPMT_Exist_BVMT}
                        apiGetMauQT_by_Tram={new Api_quantrac().GetMauQTs_By_TramQT_BVMT}
                        apiSoLan_VuotNguong={new Api_quantrac().GetBieuDo_SoLanVuotNguong_BVMT}
                        apiThongSo_Exist={new Api_quantrac().GetThongSos_Exist_BVMT}
                        apiGiaTriTimeLine={new Api_quantrac().GetBieuDo_ThongSos_GiaTris_Timeline_BVMT}
                    />
                }

                {data_modal_mau.loai === Constant.DIEM_QT_BANDO.HTMT &&
                    <InfoTramQT_HTMT
                        user={user}
                        phanloai="HTMT"
                        idTramQuanTrac={data_modal_mau.idTramQT}
                        editable={true}
                        apiGetTPMT_Exist={new Api_quantrac().GetTPMT_Exist_HTMT}
                        apiGetMauQT_by_Tram={new Api_quantrac().GetMauQTs_By_TramQT_HTMT}
                        apiSoLan_VuotNguong={new Api_quantrac().GetBieuDo_SoLanVuotNguong_HTMT}
                        apiThongSo_Exist={new Api_quantrac().GetThongSos_Exist_HTMT}
                        apiGiaTriTimeLine={new Api_quantrac().GetBieuDo_ThongSos_GiaTris_Timeline_HTMT}
                    />
                }

                {data_modal_mau.loai === Constant.DIEM_QT_BANDO.TNN &&
                    <InfoTramQT_TNNModal
                        user={user}
                        data_modal_mau={data_modal_mau}
                    />
                }

                {handleCloseModal &&
                    <ControllerButton>
                        <Button
                            type="cancel"
                            onClick={handleCloseModal}
                        >
                            <Icon type="arrow-right" />
                            {typo.cscore_exit}
                        </Button>
                    </ControllerButton>
                }

            </div>
        )
    }
}

RouterTramInfo.propTypes = {

};

export default RouterTramInfo;
